import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var BadgeContainer = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  border-radius: 40px;\n  border: ", ";\n  background: ", ";\n\n  color: ", ";\n  text-align: center;\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px; /* 133.333% */\n  letter-spacing: 0.5px;\n\n  svg {\n    font-size: 16px;\n    fill: ", ";\n  }\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  border-radius: 40px;\n  border: ", ";\n  background: ", ";\n\n  color: ", ";\n  text-align: center;\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px; /* 133.333% */\n  letter-spacing: 0.5px;\n\n  svg {\n    font-size: 16px;\n    fill: ", ";\n  }\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme, $customColor = _a.$customColor;
    return "1px solid ".concat(theme.colors[$customColor].default);
}, function (_a) {
    var theme = _a.theme, $customColor = _a.$customColor;
    return theme.colors[$customColor].default;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.white;
}, function (_a) {
    var variant = _a.variant;
    return variant;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map